import { render, staticRenderFns } from "./createMessagingConversationDialog.vue?vue&type=template&id=c920d9dc"
import script from "./createMessagingConversationDialog.vue?vue&type=script&lang=ts"
export * from "./createMessagingConversationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports